import React, { useState, useEffect } from "react";

// import "./Orders.css";
import "./Myredcash.css";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { BackToscreen } from "./Orders";
import { ToggleMenu } from "./UserProfile";
import { connect } from "react-redux";
import { getRedcashDetails, getRedcash } from "../../Redux/Actions";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import { useHistory } from "react-router-dom";

const MyRedcash = (props) => {
 
  const [myCash, setMyCash] = useState(null);
  const [myCashDetails, setMyCashDetails] = useState(null);
  const history = useHistory()
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.token;
    props.getRedcashDetails(token);
    props.getRedcash(token);
  }, []);
  useEffect(() => {
    setMyCash(props.Redcash.redcash[0]);
  }, [props.Redcash]);
  useEffect(() => {
    setMyCashDetails(props.RedcashDetails["redcash_details"]);
  }, [props.RedcashDetails]);

  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    if (!datakey) {
      history.push({
        pathname: `/login`,
        pushToUrl: "myredcash",
      });
    }
  }, []);

  return (
    <div>
      <NewHeader />
      <div className="activeDashboard">
        <div className="dashboard_content">
          <div className="back_btn">
            {/* <Link to="/userdashboard">
              <FaArrowLeft /> Back to dashboard
            </Link> */}
          </div>
          <BackToscreen title="My Redcash" />
          <div className="fleex_rows fleex_rowsMarginTop">
            <div className="dashboard_contentLeft">
              <ToggleMenu isMyRedCash={true} />
            </div>

            <div className="dashboard_contentRight">
              <div className="redCash">
                <div className="redCashTxt">RedCash</div>
                <div className="balance">
                  Balance:{" "}
                  <span
                    className="redCashValue {
"
                  >
                    ₹{myCash ? myCash["coins"] : "loading"}
                  </span>
                </div>
              </div>
              <div className="tableDiv">
                <table className="redCashTable" border="1">
                  <tr>
                    {/* <th>Details</th> */}
                    <th>Status</th>
                    {/* <th>Validity</th> */}
                    {/* <th>Current Value</th> */}
                    <th>Earned Value</th>
                    <th>Used Value</th>
                    <th>Used Date</th>
                    <th>Used With</th>
                  </tr>
                  {myCashDetails?.length > 0 &&
                    myCashDetails.map((x) => {
                      return (
                        <tr>
                          <td>{x.is_active ? "Confirmed" : "Pending"}</td>
                          <td>₹{x.earn_coins}</td>
                          <td>₹{x.redeam_coins}</td>
                          <td>
                            {x.created_at
                              .slice(0, 10)
                              .split("-")
                              .reverse()
                              .join("/")}
                          </td>
                          <td>{x.booking.id}</td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  RedcashDetails: state?.getRedcashDetailsReducer,
  Redcash: state?.getRedcashReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getRedcashDetails: (token) => {
      dispatch(getRedcashDetails(token));
    },
    getRedcash: (token) => {
      dispatch(getRedcash(token));
    },
  };
};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(MyRedcash)),
};
